export const TRANSIT_VIGNETTE_ROUTE = "/transit-vignette";
export const RESTITUTIE_VIGNETTE_ROUTE = "/restitutie";
